export const MARKETING_CAMPAIGN_TYPES = {
  SIMPLE: "ok",
  LINK: "link",
  ACTION: "action",
};

export const MARKETING_CAMPAIGN_ACTIONS = {
  PROFILE: "profil",
  ACCOUNT: "compte",
};
